import { collection, doc, getDocs, query, where, writeBatch } from "firebase/firestore";
import { firebaseStore } from "../../components/firebase/firestore";
import { PROCESSED_PUBLIC_STOCK_COLLECTION, publicProcessedStockTrace } from "./processedStockModel";
import { usesProtectedProcessedWriters } from "./processedWriterMode";

// Retain trace publication with the legacy processed editors during migration.
// In protected-writer mode, deployed shopProductSync owns synchronization.
export async function syncLegacyProcessedProductVisibility(input: {
  productDocId: string; productId: string; wasPublic: boolean; isPublic: boolean;
}): Promise<void> {
  if (usesProtectedProcessedWriters() || input.wasPublic === input.isPublic) return;
  const rows = await getDocs(query(collection(firebaseStore, "products_freezedry_batch"), where("productId", "==", input.productId)));
  for (let index = 0; index < rows.docs.length; index += 8) {
    const batch = writeBatch(firebaseStore);
    rows.docs.slice(index, index + 8).forEach((row) => {
      const stock = row.data();
      const publicData = publicProcessedStockTrace({
        productId: input.productId, packageId: stock.packageId || "", processDate: stock.processDate || "",
        processedBy: stock.processedBy || "", packingDate: stock.packingDate || "",
        packedBy: stock.packedBy || "", bestBeforeDate: stock.bestBeforeDate || "", createdAt: stock.createdAt || 0,
      }, input.productDocId, input.isPublic);
      const target = doc(firebaseStore, PROCESSED_PUBLIC_STOCK_COLLECTION, row.id);
      if (publicData) batch.set(target, publicData);
      else batch.delete(target);
    });
    await batch.commit();
  }
}
